import React from 'react';

interface CameraControlsProps {
  focalLength: number;
  onFocalLengthChange: (length: number) => void;
  onCapturePhoto: () => void;
  onRecordVideo: () => void;
  isRecording?: boolean;
  disabled?: boolean;
}

export const CameraControls: React.FC<CameraControlsProps> = ({
  focalLength,
  onFocalLengthChange,
  onCapturePhoto,
  onRecordVideo,
  isRecording = false,
  disabled = false
}) => {
  const [showFocalInfo, setShowFocalInfo] = React.useState(false);

  return (
    <div className="camera-controls">
      {/* Main Action Buttons */}
      <div className="camera-controls__buttons">
        <button
          className="camera-controls__button camera-controls__button--photo"
          onClick={onCapturePhoto}
          title="Capture Photo"
          disabled={disabled}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>
            <circle cx="12" cy="13" r="4"/>
          </svg>
          <span>Capture Photo</span>
        </button>

        <button
          className={`camera-controls__button camera-controls__button--video ${isRecording ? 'recording' : ''}`}
          onClick={onRecordVideo}
          title={isRecording ? "Stop Recording" : "Record Video"}
          disabled={disabled}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill={isRecording ? "currentColor" : "none"} stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polygon points="23 7 16 12 23 17 23 7"/>
            <rect x="1" y="5" width="15" height="14" rx="2" ry="2"/>
          </svg>
          <span>{isRecording ? 'Stop Recording' : 'Video'}</span>
        </button>
      </div>

      {/* Focal Length Slider */}
      <div className="camera-controls__focal">
        <span className="camera-controls__focal-label">
          Focal Length
        </span>
        <input
          type="range"
          min="24"
          max="200"
          value={focalLength}
          onChange={(e) => onFocalLengthChange(Number(e.target.value))}
          className="camera-controls__slider"
          disabled={disabled}
        />
        <span className="camera-controls__focal-value">{focalLength}mm</span>
        <button
          className="camera-controls__info-button"
          onMouseEnter={() => setShowFocalInfo(true)}
          onMouseLeave={() => setShowFocalInfo(false)}
          onClick={() => setShowFocalInfo(!showFocalInfo)}
          title="Info"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="16" x2="12" y2="12"/>
            <line x1="12" y1="8" x2="12.01" y2="8"/>
          </svg>
        </button>

        {/* Focal Length Info Tooltip */}
        {showFocalInfo && (
          <div className="camera-controls__focal-info">
            <strong>Focal Length:</strong>
            <p>24mm - Wide angle (large scenes)</p>
            <p>50mm - Standard (natural perspective)</p>
            <p>85mm+ - Telephoto (details, compressed perspective)</p>
          </div>
        )}
      </div>
    </div>
  );
};